import {
  CARREGA_MEU_CONTEXTO,
  CARREGA_MEU_CONTEXTO_SUCESSO,
  CARREGA_MEU_CONTEXTO_ERRO,
  ABRE_TROCA_CLIENTE,
  FECHA_TROCA_CLIENTE,
  BUSCA_CLIENTES_SELECIONAVEIS,
  CLIENTES_SELECIONAVEIS_SUCESSO,
  SELECIONA_CLIENTE_SEGURANCA,
  LIMPA_CLIENTE_ATIVO_SEGURANCA,
} from 'constants/ActionTypes';

// decideModulo: true só logo após o login — sinaliza pra saga decidir Backoffice/Portaria
// a partir do contexto recém-carregado (ver sagas/Seguranca.js). Em qualquer outro
// disparo (F5, troca de cliente) o módulo atual não é mexido.
export const carregaMeuContexto = (decideModulo = false) => {
  return {
    type: CARREGA_MEU_CONTEXTO,
    payload: { decideModulo },
  };
};

export const carregaMeuContextoSucesso = (contexto) => {
  return {
    type: CARREGA_MEU_CONTEXTO_SUCESSO,
    payload: contexto,
  };
};

export const carregaMeuContextoErro = (mensagem) => {
  return {
    type: CARREGA_MEU_CONTEXTO_ERRO,
    payload: mensagem,
  };
};

export const abreTrocaCliente = () => {
  return {
    type: ABRE_TROCA_CLIENTE,
  };
};

export const fechaTrocaCliente = () => {
  return {
    type: FECHA_TROCA_CLIENTE,
  };
};

export const buscaClientesSelecionaveis = (busca) => {
  return {
    type: BUSCA_CLIENTES_SELECIONAVEIS,
    payload: { busca },
  };
};

export const clientesSelecionaveisSucesso = (resposta) => {
  return {
    type: CLIENTES_SELECIONAVEIS_SUCESSO,
    payload: resposta,
  };
};

export const selecionaClienteSeguranca = (clienteId) => {
  return {
    type: SELECIONA_CLIENTE_SEGURANCA,
    payload: { clienteId },
  };
};

export const limpaClienteAtivoSeguranca = () => {
  return {
    type: LIMPA_CLIENTE_ATIVO_SEGURANCA,
  };
};
